module.exports = __webpack_public_path__ + "static/media/46.eeaa10c6.png";